import script from "./UiAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiAlert.vue?vue&type=script&setup=true&lang=ts"

import "./UiAlert.vue?vue&type=style&index=0&id=71942252&lang=scss"

const __exports__ = script;

export default __exports__